import { render } from "./ProductTypes.vue?vue&type=template&id=290af222&scoped=true"
import script from "./ProductTypes.vue?vue&type=script&lang=js"
export * from "./ProductTypes.vue?vue&type=script&lang=js"

import "./ProductTypes.vue?vue&type=style&index=0&id=290af222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290af222"]])

export default __exports__